import { Link } from "@tanstack/react-router";
import { Compass, User as UserIcon, LogIn } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";
import { useAuth } from "@/lib/auth-context";

export function Header() {
  const { theme } = useTheme();
  const { user } = useAuth();

  return (
    <header data-theme={theme} className="fixed top-0 left-0 right-0 z-50 bg-background border-b border-border">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-3 sm:px-5 md:px-7 py-2 sm:h-14">
        <Link to="/" aria-label="RanchPlanner home" className="flex items-center gap-2 sm:gap-2.5 group shrink-0">
          <Compass className="h-9 w-9 sm:h-[50px] sm:w-[50px] text-primary" aria-hidden="true" />
          <span className="hidden sm:flex text-2xl font-extrabold tracking-tight leading-none" style={{ fontFamily: "'Syne', sans-serif" }}>
            <span style={{ color: "#000000" }}>Ranch</span>
            <span style={{ color: "#000000" }}>Planner</span>
          </span>
        </Link>

        <nav aria-label="Primary" className="flex items-center gap-0.5 sm:gap-1 shrink-0">
          <Link
            to="/discover"
            className="inline-flex items-center gap-1 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-all"
            activeProps={{ className: "inline-flex items-center gap-1 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold text-primary bg-primary/10" }}
          >
            Discover
          </Link>
          <Link
            to="/explore"
            className="inline-flex items-center gap-1 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-all"
            activeProps={{ className: "inline-flex items-center gap-1 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium text-primary bg-primary/10" }}
          >
            Explore
          </Link>
          <Link
            to="/plan"
            className="inline-flex items-center gap-1 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-all"
            activeProps={{ className: "inline-flex items-center gap-1 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium text-primary bg-primary/10" }}
          >
            Plan
          </Link>
          {user ? (
            <Link
              to="/account"
              className="inline-flex items-center gap-1 px-2 sm:px-3 py-1.5 rounded-full text-xs sm:text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-all"
              activeProps={{ className: "inline-flex items-center gap-1 px-2 sm:px-3 py-1.5 rounded-full text-xs sm:text-sm font-semibold text-primary bg-primary/10" }}
              aria-label="Account"
            >
              <UserIcon className="h-4 w-4" />
            </Link>
          ) : (
            <Link
              to="/login"
              className="inline-flex items-center gap-1 px-2 sm:px-3 py-1.5 rounded-full text-xs sm:text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-all"
            >
              <LogIn className="h-4 w-4" /> Login
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
